import { Consultorio } from '../../models/Entities/Turnero';
import { ErrorType } from '../../models/HttpError';

export const TURNERO_CONSULTORIOS_GET_ALL_REQUEST = 'TURNERO-CONSULTORIOS_GET_ALL_REQUEST';
export const TURNERO_CONSULTORIOS_GET_ALL_SUCCESS = 'TURNERO-CONSULTORIOS_GET_ALL_SUCCESS';
export const TURNERO_CONSULTORIOS_GET_ALL_FAILURE = 'TURNERO-CONSULTORIOS_GET_ALL_FAILURE';

export interface TurneroConsultoriosGetAllRequestAction {
    type: typeof TURNERO_CONSULTORIOS_GET_ALL_REQUEST;
}

export interface TurneroConsultoriosGetAllSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_GET_ALL_SUCCESS;
    payload: Consultorio[];
}

export interface TurneroConsultoriosGetAllFailureAction {
    type: typeof TURNERO_CONSULTORIOS_GET_ALL_FAILURE;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_CREATE_REQUEST = 'TURNERO-CONSULTORIOS_CREATE_REQUEST';
export const TURNERO_CONSULTORIOS_CREATE_SUCCESS = 'TURNERO-CONSULTORIOS_CREATE_SUCCESS';
export const TURNERO_CONSULTORIOS_CREATE_FAILURE = 'TURNERO-CONSULTORIOS_CREATE_FAILURE';

export interface TurneroConsultoriosCreateRequestAction {
    type: typeof TURNERO_CONSULTORIOS_CREATE_REQUEST;
    payload: Consultorio;
}

export interface TurneroConsultoriosCreateSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_CREATE_SUCCESS;
    payload: Consultorio;
}

export interface TurneroConsultoriosCreateFailureAction {
    type: typeof TURNERO_CONSULTORIOS_CREATE_FAILURE;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_REQUEST = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_REQUEST';
export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_SUCCESS = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_SUCCESS';
export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_FAILURE = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_FAILURE';

export interface TurneroConsultoriosGetDisponiblesRequestAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_REQUEST;
}

export interface TurneroConsultoriosGetDisponiblesSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_SUCCESS;
    payload: Consultorio[];
}

export interface TurneroConsultoriosGetDisponiblesFailureAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_FAILURE;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_REQUEST = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_REQUEST';
export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_SUCCESS = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_SUCCESS';
export const TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE = 'TURNERO-CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE';

export interface TurneroConsultoriosGetDisponiblesDoctorRequestAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_REQUEST;
    doctorId: string;
    medicoId?: number;
}

export interface TurneroConsultoriosGetDisponiblesDoctorSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_SUCCESS;
    doctorId: string;
    medicoId?: number;
    payload: Consultorio[];
}

export interface TurneroConsultoriosGetDisponiblesDoctorFailureAction {
    type: typeof TURNERO_CONSULTORIOS_GET_DISPONIBLES_DOCTOR_FAILURE;
    doctorId: string;
    medicoId?: number;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_UPDATE_REQUEST = 'TURNERO-CONSULTORIOS_UPDATE_REQUEST';
export const TURNERO_CONSULTORIOS_UPDATE_SUCCESS = 'TURNERO-CONSULTORIOS_UPDATE_SUCCESS';
export const TURNERO_CONSULTORIOS_UPDATE_FAILURE = 'TURNERO-CONSULTORIOS_UPDATE_FAILURE';

export interface TurneroConsultoriosUpdateRequestAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_REQUEST;
    id: number;
    consultorio: Consultorio;
}

export interface TurneroConsultoriosUpdateSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_SUCCESS;
    id: number;
    consultorio: Consultorio;
    payload: string;
}

export interface TurneroConsultoriosUpdateFailureAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_DELETE_REQUEST = 'TURNERO-CONSULTORIOS_DELETE_REQUEST';
export const TURNERO_CONSULTORIOS_DELETE_SUCCESS = 'TURNERO-CONSULTORIOS_DELETE_SUCCESS';
export const TURNERO_CONSULTORIOS_DELETE_FAILURE = 'TURNERO-CONSULTORIOS_DELETE_FAILURE';

export interface TurneroConsultoriosDeleteRequestAction {
    type: typeof TURNERO_CONSULTORIOS_DELETE_REQUEST;
    id: number;
}

export interface TurneroConsultoriosDeleteSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_DELETE_SUCCESS;
    payload: number;
}

export interface TurneroConsultoriosDeleteFailureAction {
    type: typeof TURNERO_CONSULTORIOS_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_CONSULTORIOS_UPDATE_ESTADO_REQUEST = 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_REQUEST';
export const TURNERO_CONSULTORIOS_UPDATE_ESTADO_SUCCESS = 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_SUCCESS';
export const TURNERO_CONSULTORIOS_UPDATE_ESTADO_FAILURE = 'TURNERO-CONSULTORIOS_UPDATE_ESTADO_FAILURE';

export interface TurneroConsultoriosUpdateEstadoRequestAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_ESTADO_REQUEST;
    id: number;
    estado: string;
}

export interface TurneroConsultoriosUpdateEstadoSuccessAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_ESTADO_SUCCESS;
    id: number;
    estado: string;
    payload: string;
}

export interface TurneroConsultoriosUpdateEstadoFailureAction {
    type: typeof TURNERO_CONSULTORIOS_UPDATE_ESTADO_FAILURE;
    id: number;
    estado: string;
    error: ErrorType;
}
